import { Thumbnail } from 'components/table/utility/Thumbnail'
import React from 'react'

import { Asset3DModelImage } from './Asset3DModelImage'

interface FallbackImageProps {
  assetModelType?: string
  showThumbnail?: boolean
}

export const FallbackImage: React.FC<FallbackImageProps> = ({
  assetModelType,
  showThumbnail,
}) => {
  return assetModelType ? (
    <Asset3DModelImage
      assetModelType={assetModelType}
      showThumbnail={showThumbnail}
    />
  ) : showThumbnail ? (
    <Thumbnail />
  ) : null
}
